import * as React from "react";
import {
  Box,
  Button,
  Container,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { Helmet } from "react-helmet-async";
import { canonicalUrl } from "../../common/seo";

const PATH = "/contact";

export function ContactPage() {
  const title = "Contact | NWA Blog";
  const description =
    "Send a note to NWA Blog. Use this form for general questions, feedback, or content requests.";

  return (
    <Container component="section" sx={{ marginTop: "5rem" }}>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonicalUrl(PATH)} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl(PATH)} />
      </Helmet>

      <Paper elevation={1} sx={{ padding: "1rem", textAlign: "center" }}>
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
          Contact
        </Typography>
        <Typography variant="body2" sx={{ marginTop: ".5rem" }}>
          Questions, feedback, or a spot we should check out? Send a message.
        </Typography>
      </Paper>

      <Paper elevation={2} sx={{ marginTop: "1rem", padding: "1rem" }}>
        <Box
          component="form"
          name="contact"
          method="POST"
          data-netlify="true"
          netlify-honeypot="bot-field"
          action="/contact-success"
          sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}
        >
          <input type="hidden" name="form-name" value="contact" />

          <Box sx={{ display: "none" }}>
            <label>
              Don't fill this out if you're human: <input name="bot-field" />
            </label>
          </Box>

          <TextField label="Name *" name="name" required fullWidth />
          <TextField
            label="Email *"
            name="email"
            type="email"
            required
            fullWidth
          />
          <TextField label="Phone" name="phone" type="tel" fullWidth />
          <TextField label="Company" name="company" fullWidth />
          <TextField
            label="Message *"
            name="message"
            required
            fullWidth
            multiline
            rows={5}
            placeholder="Tell us what's on your mind..."
          />

          <Button
            type="submit"
            variant="contained"
            sx={{
              bgcolor: "accent.main",
              color: "#fff",
              "&:hover": { bgcolor: "accent.main" },
            }}
          >
            Send Message
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
